import gsap from 'gsap';
import EventDispatcher from './EventDispatcher';
import Global from './Global';
const chckWithTick = '/assets/UI/Check-box-with-tick.png';
const chckWithoutTick = '/assets/UI/Check-box-without-tick.png';
import jQuery from 'jquery';
const $ = jQuery;
export default class SignIn {
  constructor() {
    document
      .querySelector('#signin_btn')
      .addEventListener('click', this.onSubmit.bind(this));
    // document
    //   .querySelector('#checkboxLogin')
    //   .addEventListener('click', this.onCheckboxClick.bind(this));
    // document
    //   .querySelector('#checkbox2Login')
    //   .addEventListener('click', this.onCheckboxClick2.bind(this));
    // document
    //   .querySelector('#checkbox3Login')
    //   .addEventListener('click', this.onCheckboxClick3.bind(this));
    document
      .querySelector('#backSignIn_btn')
      .addEventListener('click', this.onBack.bind(this));
    document
      .querySelector('#phoneCodeSignIn')
      .addEventListener('change', this.onChangeCountry.bind(this));
    this.checkboxBool = false;
    this.checkboxBool2 = false;
    this.checkboxBool3 = false;
    this.loginType = 'email';
    this.formBool = false;
  }

  init() {
    this.isChecked = true;

    this.events = EventDispatcher.getObj();
    this.events.addEventListener('LOADER_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAME_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));

    document.querySelector('#loginEmail').addEventListener('focus', () => {
      this.loginType = 'email';
    });
    document.querySelector('#loginMobile').addEventListener('focus', () => {
      this.loginType = 'mobile';
    });

    // setTimeout(()=>{
    //     this.onOkay();
    // }, 1000)
  }

  onEvents(data) {
    switch (data.message.event_type) {
      case 'show_screen':
        this.showScreen(data.message.data.screenKey);
        break;
    }
  }

  onBack() {
    Global.clickUpdater('backSignIn_btn');
    this.events.dispatchEvent({
      type: 'LOADER_EVENTS',
      message: {
        event_type: 'switch_page',
        data: {
          screenKey: 'SignupSignin',
        },
      },
    });
  }

  showScreen(screenKey) {
    if (screenKey != 'SignIn') return false;
    this.pageAnimation();
    Global.countryCode = '';
    document.querySelectorAll('input, select').forEach((el) => {
      if (el.type === 'checkbox' || el.type === 'radio') {
        el.checked = false;
      } else {
        el.value = '';
      }
    });

    document.querySelector('#signin_scr').classList.add('active');
  }

  pageAnimation() {
    gsap.set('#signin_btn', { opacity: 0 });
    gsap.fromTo(
      '#signin_scr > .appContainer',
      { scale: 0.2, opacity: 0 },
      { scale: 1, opacity: 1, duration: 1, ease: 'power3.out' }
    );
    setTimeout(() => {
      // Animate to final position and full opacity

      this.events.dispatchEvent({
        type: 'ANIMATION_EVENTS',
        message: {
          event_type: 'buttonAnimation',
          data: {
            selector: '#signin_btn',
          },
        },
      });
    }, 1000);
  }

  onChangeCountry() {
    Global.countryCode = document.querySelector('#phoneCodeSignIn').value;
  }

  onSubmit() {
    if (this.formBool) {
      return;
    }
    let loginValue = '';

    if (this.loginType == 'email') {
      loginValue = document.getElementById('loginEmail').value;
      const regex =
        /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (loginValue == '' || loginValue == null) {
        showError(Global.language.emailError[Global.lang]);
        Global.signInError = 'emailError';
        return;
      } else if (!regex.test(loginValue)) {
        showError(Global.language.emailErrorValid[Global.lang]);
        Global.signInError = 'emailErrorValid';
        return;
      }
      // else if (!this.checkboxBool) {
      //   showError(Global.language.tncError[Global.lang]);
      //   Global.signInError = 'tcError';
      //   return;
      // } else if (!this.checkboxBool3) {
      //   showError(Global.language.ageError[Global.lang]);
      //   Global.signInError = 'ageError';
      //   return;
      // }
    } else {
      loginValue = document.getElementById('loginMobile').value;
      const mobile_regx = /^(\+\d{1,3}[- ]?)?\d{8,11}$/;
      if (loginValue == '' || loginValue == null) {
        showError(Global.language.mobileError[Global.lang]);
        Global.signInError = 'mobileError';
        return;
      } else if (!mobile_regx.test(loginValue)) {
        showError(Global.language.mobileErrorValid[Global.lang]);
        Global.signInError = 'mobileErrorValid';
        return;
      } else if (Global.countryCode == '') {
        showError(Global.language.countryError[Global.lang]);
        Global.signInError = 'countryError';
        return;
      }
      // else if (!this.checkboxBool) {
      //   showError(Global.language.tncError[Global.lang]);
      //   Global.signInError = 'tncError';
      //   return;
      // } else if (!this.checkboxBool3) {
      //   showError(Global.language.ageError[Global.lang]);
      //   Global.signInError = 'ageError';
      //   return;
      // }
      loginValue = Global.countryCode + loginValue;
    }
    this.formBool = true;
    Global.serverObj.send(
      `${Global.BASE_URL}login.php`,
      (response) => {
        const data = JSON.parse(response);
        // let data = response;

        this.formBool = false;

        if (data.code == 200) {
          Global.loginStatus = true;
          Global.U_ID = data.uid;
          Global.gameID = Global.U_ID;
          Global.gameKey = data.gameKey;
          Global.name = data.name;
          Global.email = data.email;
          Global.mobile = data.mobile;
          Global.country = data.country;
          Global.pack = data.pack;
          Global.gameTry = parseInt(data.gameTry);

          localStorage.setItem('U_ID', Global.U_ID);
          localStorage.setItem('name', Global.name);
          localStorage.setItem('email', Global.email);
          localStorage.setItem('gameKey', Global.gameKey);
          localStorage.setItem('mobile', Global.mobile);
          localStorage.setItem('country', Global.country);
          localStorage.setItem('pack', Global.pack);
          localStorage.setItem('click_id', Global.click_id);
          localStorage.setItem('gameTry', Global.gameTry);

          document.querySelector('#homeBtn').classList.add('active');
          Global.clickUpdater('signin_btn');
          if (Global.expType == 'vote') {
            this.events.dispatchEvent({
              type: 'LOADER_EVENTS',
              message: {
                event_type: 'switch_page',
                data: {
                  screenKey: 'show_leader',
                },
              },
            });
          } else {
            this.events.dispatchEvent({
              type: 'LOADER_EVENTS',
              message: {
                event_type: 'switch_page',
                data: {
                  screenKey: 'show_selection',
                },
              },
            });
          }
        } else if (data.code == 400) {
          // showError(data.message)
          $('.errorBox').hide();
          $('.signinError').show();
          document.querySelector('#error_scr').style.display = 'flex';
          gsap.set('#error_scr .biscuit1', { x: -200, opacity: 0 });
          gsap.set('#error_scr .biscuit2', { x: 200, opacity: 0 });
          gsap.set('#signInError_btn', { opacity: 0 });
          gsap.fromTo(
            '#error_scr > .appContainer',
            { scale: 0.2, opacity: 0 },
            { scale: 1, opacity: 1, duration: 1, ease: 'power3.out' }
          );
          setTimeout(() => {
            // Animate to final position and full opacity
            gsap.to('#error_scr .biscuit1', {
              x: 0,
              opacity: 1,
              duration: 1,
              ease: 'power3.out',
            });

            gsap.to('#error_scr .biscuit2', {
              x: 0,
              opacity: 1,
              duration: 1,
              ease: 'power3.out',
              delay: 0.2,
            });
            this.events.dispatchEvent({
              type: 'ANIMATION_EVENTS',
              message: {
                event_type: 'buttonAnimation',
                data: {
                  selector: '#signInError_btn',
                },
              },
            });
          }, 1000);
        }
      },
      null,
      {
        loginValue,
        loginType: this.loginType,
        uniqID: Global.U_ID,
        saveType: 'loginUser',
      },
      'POST',
      null,
      false
    );

    function showError(msg) {
      document.querySelector('#errorLogin').innerHTML = msg;
      document.querySelector('#errorLogin').classList.add('active');
    }
  }

  onCheckboxClick() {
    const checkbox = document.getElementById('checkboxLogin');
    this.checkboxBool = !this.checkboxBool;
    checkbox.src = this.checkboxBool ? chckWithTick : chckWithoutTick;
  }

  onCheckboxClick2() {
    const checkbox = document.getElementById('checkbox2Login');
    this.checkboxBool2 = !this.checkboxBool2;
    checkbox.src = this.checkboxBool2 ? chckWithTick : chckWithoutTick;
  }

  onCheckboxClick3() {
    const checkbox = document.getElementById('checkbox3Login');
    this.checkboxBool3 = !this.checkboxBool3;
    checkbox.src = this.checkboxBool3 ? chckWithTick : chckWithoutTick;
  }
}
